<template>
	<div>
		<div class="editable-cell-renderer">
			<div>{{ localParams.value }}</div>
			<div class="edit-pencil">
				<SIcon name="edit-interface-structure" class="mr-1" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EditableCellRenderer',
	computed: {
		localParams() {
			return this.params || {};
		},
	},
};
</script>

<style lang="scss">
// This is generaly on the app which is far from idel and an opening for bugs
// but at least this is name spaced with 'editable-cell-renderer'

.editable-cell-renderer {
	position: relative;

	.edit-pencil {
		position: absolute;
		right: 2px;
		top: 50%;
		transform: translateY(-50%);

		svg path {
			stroke: #cacaca;
		}
	}
	&:hover .edit-pencil {
		transition: 0.3s;
		opacity: 1;
	}
	&:not(:hover) .edit-pencil {
		opacity: 0;
		transition: 0.2s;
	}
}
</style>
